import { Reward } from '../User'
import * as BookTypes from './Book.types'
import api from '../../../api/api'
import { ApiRequestParams, Paginated } from 'utils/types'

const BOOKS_FETCH_LIMIT = 400

export const getBookProgress = async () => {
  const params: ApiRequestParams = {
    $limit: 1000
  }

  const { data } = await api.get<Paginated<BookTypes.BookProgress>>('/book-progress', { params })

  return data.results
}

export const getAllBooks = async (
  search?: string,
  { offset = 0, prevBooks = [] }: { offset?: number; prevBooks?: BookTypes.Book[] } = {}
): Promise<BookTypes.Book[]> => {
  const params: ApiRequestParams = {
    $limit: BOOKS_FETCH_LIMIT,
    $skip: offset,
    ...(typeof search === 'string' && search.length > 2 ? { $search: search } : {})
  }
  const { data } = await api.get<Paginated<BookTypes.Book>>('/book', { params })

  const allBooks = [...prevBooks, ...data.results]

  const shouldFetchMore = data.status.total > data.status.offset + BOOKS_FETCH_LIMIT
  if (shouldFetchMore) {
    return getAllBooks(search, { offset: data.status.offset + BOOKS_FETCH_LIMIT, prevBooks: allBooks })
  } else {
    return allBooks
  }
}

export const createBookProgress = async (bookId: string) => {
  const { data } = await api.post<BookTypes.BookProgress>('/book-progress', {
    bookId,
    index: 0,
    isCompleted: false
  })

  return data
}

export const updateBookProgress = (data: {
  index: number
  progressId: string
  isCompleted: boolean
  bookMode: BookTypes.BookMode
}) => {
  const preparedData =
    data.bookMode === BookTypes.BookMode.READ
      ? {
          index: data.index,
          isCompleted: data.isCompleted
        }
      : {
          indexListening: data.index,
          isCompletedListening: data.isCompleted
        }

  return api.patch<BookTypes.BookProgress>(`/book-progress/${data.progressId}`, preparedData)
}

export const updateIsBookFavorite = (
  bookProgressId: string,
  updatedValues: { reading?: boolean; listening?: boolean }
) => api.patch<BookTypes.BookProgress>(`/book-progress/${bookProgressId}/favorite`, updatedValues)

export const rateBook = (bookProgressId: string, rate: BookTypes.BookRate) =>
  api.patch<BookTypes.BookProgress>(`/book-progress/${bookProgressId}/rate`, { rating: rate })

export const getPlacementTest = () => api.get<BookTypes.PlacementTest>(`/placement-test`)

export const createPlacementTestScore = (placementTestId: string) =>
  api.post<BookTypes.PlacementTestScore>('/placement-test-score', { placementTestId })

export const updatePlacementTestScore = ({
  placementId,
  exerciseId,
  score
}: {
  placementId: string
  exerciseId: string
  score: number
}) =>
  api.post<BookTypes.PlacementTestScore>(`/placement-test-score/${placementId}`, {
    exerciseId,
    score
  })

export const getReceivedRewardsByBook = async (
  book: BookTypes.Book,
  bookMode: BookTypes.BookMode
): Promise<Reward[]> => {
  try {
    const { data } = await api.get<Reward[]>('/reward', {
      params: {
        bookId: book._id,
        bookType: bookMode === BookTypes.BookMode.READ ? BookTypes.BookType.Reading : BookTypes.BookType.Listening
      }
    })

    return data
  } catch (error) {
    return []
  }
}
